export default __webpack_public_path__ + "d444f2b27c61ace3ff64867686c18256.png";